import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Challenge from "@/pages/Challenge";
import Share from "@/pages/Share";
import AdvancedReport from "@/pages/AdvancedReport";
import Billing from "@/pages/Billing";
import PasswordReset from "@/pages/PasswordReset";
import VerifyEmail from "@/pages/VerifyEmail";
import GoogleCallback from "@/pages/GoogleCallback";
import Plus from "@/pages/Plus";
import PlusSession from "@/pages/PlusSession";
import Review from "@/pages/Review";
import AdminDrafts from "@/pages/AdminDrafts";

function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <GoogleCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/assessment/:aid" element={<Assessment />} />
      <Route path="/results/:aid" element={<Results />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/drafts" element={<AdminDrafts />} />
      <Route path="/review/:aid" element={<Review />} />
      <Route path="/challenge/:aid" element={<Challenge />} />
      <Route path="/share/:aid" element={<Share />} />
      <Route path="/report/:aid" element={<AdvancedReport />} />
      <Route path="/billing" element={<Billing />} />
      <Route path="/reset" element={<PasswordReset />} />
      <Route path="/verify" element={<VerifyEmail />} />
      <Route path="/plus" element={<Plus />} />
      <Route path="/plus/session/:sid" element={<PlusSession />} />
      <Route path="/plus/session/:sid/results" element={<PlusSession />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-[#070C18] min-h-screen text-slate-100">
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}
export default App;
